import { Component, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of, Subject } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { PermissionsEnum } from 'src/app/enums/permissions.enum';
import { DatasheetSession } from 'src/app/models/database/datasheet-session.model';
import { AsyncValidatorsService } from 'src/app/services';
import { PepService } from 'src/app/services/http/pep/pep.service';
import { PermissionService } from 'src/app/services/http/permission/permission.service';
import { SnackbarService } from 'src/app/services/utils/snackbar/snackbar.service';

@Component({
  selector: 'app-edit-datasheet-section',
  templateUrl: './edit-datasheet-section.component.html',
  styleUrls: ['./edit-datasheet-section.component.scss']
})
export class EditDatasheetSectionComponent {

  verifyUserPermission$: Observable<boolean> = this.permissionService.verify(PermissionsEnum.EDIT_DATASHEET)
  @Input() session: DatasheetSession

  @ViewChild('editDatasheetSectionModal') editDatasheetSectionModal: TemplateRef<any>
  modalReference: NgbModalRef

  editSectionFormGroup: FormGroup
  formSubmitted: boolean
  editingSection: boolean

  @Output() sessionEdited: Subject<number> = new Subject<number>()

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private pepService: PepService,
    private _asyncValidators: AsyncValidatorsService,
    private permissionService: PermissionService,
    private snackbarService: SnackbarService
  ) { }

  openModal(): void {
    this.editSectionFormGroup = this.formBuilder.group({
      description: [this.session.description, [Validators.required], [this._asyncValidators.datasheetSectionDoesntExist(this.session.datasheetId, this.session.id)]],
      order: [this.session.order, [Validators.required]]
    })
    this.formSubmitted = false
    this.editingSection = false
    this.modalReference = this.modalService.open(this.editDatasheetSectionModal)
  }

  editDatasheetSection(): void {
    this.formSubmitted = true
    if (this.editSectionFormGroup.valid && !this.editingSection) {
      let session: DatasheetSession = this.editSectionFormGroup.value
      session.id = this.session.id
      session.datasheetId = this.session.datasheetId
      this.editingSection = true
      this.pepService.editDatasheetSession(session)
        .pipe(
          take(1),
          catchError(error => {
            this.snackbarService.showError('Seção da ficha não foi editada, por favor tente novamente mais tarde.')
            this.editingSection = false
            return of(null)
          })
        )
        .subscribe((datasheetSectionId: number) => {
          this.sessionEdited.next(datasheetSectionId)
          this.modalReference.close()
          this.snackbarService.show('Seção da ficha editada.')
        })
    }
  }

  //getters

  get descriptionIsInvalid(): boolean {
    return this.editSectionFormGroup.controls['description'].invalid
  }

  get descriptionWasntInformed(): boolean {
    return this.editSectionFormGroup.controls['description'].errors?.['required']
  }

  get descriptionAlreadyExists(): boolean {
    return this.editSectionFormGroup.controls['description'].errors?.['datasheetSectionDoesntExist']
  }

  get orderIsInvalid(): boolean {
    return this.editSectionFormGroup.controls['order'].invalid
  }

  get orderWasntInformed(): boolean {
    return this.editSectionFormGroup.controls['order'].errors?.['required']
  }
}